export const SETTINGS = {
  CUSTOMIZED: 'CUSTOMIZED',
  INVOICE_TERMS_AND_CONDITIONS: 'INVOICE_TERMS_AND_CONDITIONS',
  SCH_TASK_COMPLETED_COLOR: 'SCH_TASK_COMPLETED_COLOR',
  SCH_TASK_CANCELLED_COLOR: 'SCH_TASK_CANCELLED_COLOR',
  SCH_TASK_OPEN_COLOR: 'SCH_TASK_OPEN_COLOR',
  SCH_TASK_SCHEDULED_COLOR: 'SCH_TASK_SCHEDULED_COLOR',
  SCH_TASK_ONGOING_COLOR: 'SCH_TASK_ONGOING_COLOR',
  SCH_TASK_INVOICED_COLOR: 'SCH_TASK_INVOICED_COLOR',
  PAYMENT_OPTIONS: 'PAYMENT_OPTIONS',
  PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER: 'PAYMENT_OPTIONS_WIRE_TRANSFER_ACCOUNT_NUMBER',
}